import { useNavigate } from 'react-router-dom'
import DuplicateRadioGroup from '../DuplicateFindingRadioGroup'
import { PrimaryButton, SecondaryButton } from '../ui/Button'
import Modal from './Modal'
import { useLayoutContext } from '../../context/LayoutContext'
import { ResultAsync } from 'neverthrow'
import { recreateBinding, setRangeValues } from '../../workbook'
import { toast } from 'react-toastify'
import { deleteReferencesWithBindingIds } from '../../slice/referenceSlice'
import { useAppDispatch } from '../../dispatch'

const DuplicateModal = () => {
  const { state: store, dispatch: storeDispatch } = useLayoutContext()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const selected = store.selected
  const referenceGroup = store.referenceGroup
  const openPopup = store.openPopup

  const confirmSelectedDuplicate = async () => {
    if (selected !== '') {
      const selectedDuplicate = referenceGroup.find(
        (ref) => ref.bindingId === selected
      )
      if (!selectedDuplicate) return
      const toBeDelete = referenceGroup
        .filter((ref) => ref.bindingId !== selected)
        .map((ref) => ref.bindingId)
      console.log(selectedDuplicate.bindingId, toBeDelete)
      const setRangeValueResult = await ResultAsync.fromPromise(
        setRangeValues(
          selectedDuplicate.sheetId,
          selectedDuplicate.rangeAddr,
          selectedDuplicate.values
        ),
        (error) =>
          new Error(
            `setRangeValueResult error: ${
              error instanceof Error ? JSON.stringify(error) : error
            }`
          )
      )

      if (setRangeValueResult.isErr()) {
        toast.error(
          `Unable to set value to output range, error: ${setRangeValueResult.error}`
        )
        return
      }

      const recreateBindingResult = await ResultAsync.fromPromise(
        recreateBinding(
          selectedDuplicate.bindingGroupId ?? selectedDuplicate.bindingId,
          selectedDuplicate.bindingId,
          selectedDuplicate.sheetId,
          selectedDuplicate.rangeAddr
        ),
        (error) =>
          new Error(
            `Unable to recreate binding, error: ${
              error instanceof Error ? JSON.stringify(error) : error
            }`
          )
      )

      if (recreateBindingResult.isErr()) {
        toast.error(
          `⚠️Unable to recreate binding, error: ${recreateBindingResult.error}`
        )
        return
      }

      const deleteReferencesWithBindingIdsResult =
        await ResultAsync.fromPromise(
          dispatch(
            deleteReferencesWithBindingIds({
              bindingIds: toBeDelete,
              deleteGroup: false,
            })
          ),
          (error) =>
            new Error(
              `deleteReferencesWithBindingIds error: ${
                error instanceof Error ? JSON.stringify(error) : error
              }`
            )
        )

      if (deleteReferencesWithBindingIdsResult.isErr()) {
        toast.error(
          `Unable to delete related bindings for duplicate result, errror: ${deleteReferencesWithBindingIdsResult.error}`
        )
      }
    }
  }

  const confirmSelectedDuplicateWrapper = () => {
    confirmSelectedDuplicate()
      .catch((err) => console.error(`confirmSelectedDuplicate error=${err}`))
      .finally(() => {
        storeDispatch({
          type: 'BATCH',
          payload: {
            openPopup: false,
            referenceGroup: [],
            selected: '',
          },
        })
      })
  }

  return (
    <div className="w-72 flex">
      <Modal
        isOpen={openPopup}
        setIsOpen={(val: boolean) =>
          storeDispatch({
            type: 'SET_OPEN_POPUP',
            payload: val,
          })
        }
        size="sm"
      >
        <Modal.Header
          onClose={() =>
            storeDispatch({
              type: 'SET_OPEN_POPUP',
              payload: false,
            })
          }
        >
          Duplicate Findings
        </Modal.Header>
        <Modal.Separator />
        <Modal.Body>
          <div className={`mt-2 overflow-y-auto`}>
            <div className="text-sm text-gray-500">
              <DuplicateRadioGroup
                rects={referenceGroup}
                selected={selected}
                setSelected={(val: string) =>
                  storeDispatch({
                    type: 'SET_SELECTED',
                    payload: val,
                  })
                }
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <PrimaryButton
            onClick={() => {
              if (selected !== '') {
                const rect = referenceGroup.find(
                  (re) => re.bindingId === selected
                )
                if (rect) {
                  navigate(`/file/${rect.fileId}`, {
                    state: { page: rect.filePage, top: rect.top ?? 0 },
                  })
                }
              }
              storeDispatch({
                type: 'SET_OPEN_POPUP',
                payload: false,
              })
            }}
          >
            View
          </PrimaryButton>
          <SecondaryButton onClick={confirmSelectedDuplicateWrapper}>
            Confirm
          </SecondaryButton>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default DuplicateModal
